import React, { Component } from "react";
import NewForm from "../../new/NewForm";
import "../../../../assets/css/view/formulario/list/tabs/formLayout.css";

export default class FormLayout extends Component {
  render() {
    return (
      <div id="form-layout">
        <NewForm id={this.props.params.id} editable />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/view/formulario/list/tabs/FormLayout.js